import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants/index";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import moment from "moment";

const ExpenseAdvanceReport = () => {

  const dispatch = useDispatch();
  useEffect(() => {
    fetchExpenseAdvanceReport();

    dispatch(updateNavbarHeading("Expense Advance Report"));
  }, []);

  const todayDate = moment().format("YYYY-MM-DD");
  const lastMonthDate = moment().subtract(1, "months").format("YYYY-MM-DD");

  const initialdata = [
    { label: "Employee", value: "" },
    { label: "Status", value: "" },
    { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
  ]

  const [expenseData, setExpenseData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [empList, setEmplist] = useState([]);
  const [Status, setStatus] = useState([]);
  const [filterFormData, setFilterData] = useState(initialdata);
  const [apiStatus, SetApiStatus] = useState(undefined);

  const columns = {
    TXNName: { text: "Receipt No.", visible: true },
    TXNDate: { text: "Receipt Date", align: "center", visible: true },
    Project: { text: "Project", visible: true },
    Employee: { text: "Employee", visible: true },
    AdvanceAmount: { text: "Advance Amt. \u20B9", align: "end", visible: true },
    CashAmount: { text: "Cash Amt. \u20B9", align: "end", visible: true },
    CardAmount: { text: "Card Amt. \u20B9", align: "end", visible: true },
    TotalAmount: { text: "Total Amt. \u20B9", align: "end", visible: true },
    BalanceAmount: { text: "Balance Amt. \u20B9", align: "end", visible: true },
    ApprovedAmount: { text: "Approved Amt. \u20B9", align: "end", visible: true },
    StatusName: { text: "Status", visible: true },
  };


  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const fetchExpenseAdvanceReport = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/report/3?P_EmployeeID=&P_FromDate=${lastMonthDate}&P_ToDate=${todayDate}&P_Status=`
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const ExpenseData = response?.data?.data?.header;
        setExpenseData(ExpenseData);
        // Employee list
        const empList = response?.data?.data?.employeeList?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmplist(empList);

        // status list
        const statusList = response?.data?.data?.status?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setStatus(statusList);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };

  const handleGetData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/report/3?P_EmployeeID=${filterFormData.find((o) => o.label === "Employee")
          ? filterFormData.find((o) => o.label === "Employee").value
          : ""
        }&P_FromDate=${filterFormData.find((o) => o.label === "From Date")
          ? moment(
            filterFormData.find((o) => o.label === "From Date").value
          ).format("YYYY-MM-DD")
          : lastMonthDate
        }&P_ToDate=${filterFormData.find((o) => o.label === "To Date")
          ? moment(
            filterFormData.find((o) => o.label === "To Date").value
          ).format("YYYY-MM-DD")
          : todayDate
        }&P_Status=${filterFormData.find((o) => o.label === "Status")
          ? filterFormData.find((o) => o.label === "Status").value
          : 0
        }`
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const ExpenseData = response?.data?.data?.header;
        setExpenseData(ExpenseData);
        // Employee list
        const empList = response?.data?.data?.employeeList?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmplist(empList);

        // status list
        const statusList = response?.data?.data?.status?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setStatus(statusList);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };
  const formDatas = [
    { name: "Employee", type: "Select", options: [...empList] },
    { name: "Status", type: "Select", options: [...Status] },
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
  ];


  const handleReset = () => {
    setFilterData(initialdata)
    fetchExpenseAdvanceReport();
  }
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={expenseData}
              columns={columns}
              itemsPerPage={10}
              handleReset={handleReset}
              searchTerm={searchTerm}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              setSearchTerm={setSearchTerm}
              isFilterRequired={true}
              formDatas={formDatas}
              isSorting={true}
              handleGetData={handleGetData}
              handleChange={handleChange}
              filterFormData={filterFormData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpenseAdvanceReport;
